/**
 * @generated SignedSource<<d79a6bf1e369f32b72953149e0187457>>
 * @relayHash c3d2da7e46989747a49571a99dfbfa64
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/549.0.0-2026-03-06T17:27:41.757Z/modifyEthereumWalletConnectionMutation

import { ConcreteRequest } from 'relay-runtime';
export type ModifySocialNetworkConnectionAction = "CONNECT" | "DISCONNECT" | "%future added value";
export type ModifySocialNetworkConnectionFailureReason = "WALLET_ALREADY_CONNECTED" | "%future added value";
export type SocialNetworkNames = "APPLE" | "ETHEREUM" | "FACEBOOK" | "GOOGLE" | "INSTAGRAM" | "PINTEREST" | "%future added value";
export type ModifySocialNetworkConnectionInput = {
  accessToken?: string | null;
  action: ModifySocialNetworkConnectionAction;
  address?: string | null;
  clientMutationId?: string | null;
  message?: string | null;
  redirectUri?: string | null;
  signature?: string | null;
  socialClientId?: string | null;
  socialNetworkName?: SocialNetworkNames | null;
  socialUserEmail?: string | null;
  socialUserFirstName?: string | null;
  socialUserLastName?: string | null;
  userId: string;
  userSocialNetworkId?: string | null;
  zipCode?: string | null;
};
export type modifyEthereumWalletConnectionMutation$variables = {
  input: ModifySocialNetworkConnectionInput;
};
export type modifyEthereumWalletConnectionMutation$data = {
  readonly modifySocialNetworkConnection: {
    readonly bidderRoleTransactionHash: string | null;
    readonly failureReason: ModifySocialNetworkConnectionFailureReason | null;
    readonly removedId: string | null;
    readonly user: {
      readonly ethereumWalletAddress: {
        readonly address: string | null;
      } | null;
      readonly serviceId: string | null;
      readonly socialNetworkByName: {
        readonly serviceId?: string | null;
        readonly userPreferences?: {
          readonly accessToken: string | null;
          readonly zipCode: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type modifyEthereumWalletConnectionMutation = {
  response: modifyEthereumWalletConnectionMutation$data;
  variables: modifyEthereumWalletConnectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bidderRoleTransactionHash",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failureReason",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "socialNetworkName",
    "value": "ETHEREUM"
  }
],
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumSocialConnectionUserPreferencesType",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "zipCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EthereumSocialConnection",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "modifyEthereumWalletConnectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifySocialNetworkConnectionPayload",
        "kind": "LinkedField",
        "name": "modifySocialNetworkConnection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "ethereumWalletAddress",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "socialNetworkByName",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": "socialNetworkByName(socialNetworkName:\"ETHEREUM\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "modifyEthereumWalletConnectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifySocialNetworkConnectionPayload",
        "kind": "LinkedField",
        "name": "modifySocialNetworkConnection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "ethereumWalletAddress",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "socialNetworkByName",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": "socialNetworkByName(socialNetworkName:\"ETHEREUM\")"
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/549.0.0-2026-03-06T17:27:41.757Z/modifyEthereumWalletConnectionMutation",
    "metadata": {},
    "name": "modifyEthereumWalletConnectionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f73cac6e361cff73ee5f173bd2c97986";

export default node;
